import React from "react";
import "./Button.css";

const Style = ["btn--solid", "btn--outline", "btn--icon-outline"];
const Size = ["btn--icon-size", "btn--size", "btn--min", "btn--sizeMargin"];

export default function Button({
  children,
  type,
  onClick,
  buttonStyle,
  buttonSize,
  disabled,
  bgColor,
  customWidth,
  customebackground
}) {
  const checkButtonStyle = Style.includes(buttonStyle) ? buttonStyle : Style[0];
  const checkButtonSize = Size.includes(buttonSize) ? buttonSize : Size[0];
  return (
    <button
      className={`btn ${checkButtonStyle} ${checkButtonSize}`}
      onClick={onClick}
      type={type}
      disabled={disabled}
      style={{background: `${customebackground}`, backgroundColor:`${bgColor}`, borderRadius:'8px', width: `${customWidth}`, }}
    >
      {children}
    </button>
  );
}
